import "flowbite";

const GUEST_RESET_PARAM = "_pwa_reset";
const GUEST_RESET_FLAG = "guest-pwa-reset-done";
const GUEST_CACHE_PREFIXES = [
    "pages-",
    "app-data-",
    "font-styles-",
    "font-files-",
    "static-assets-",
    "images-",
];
const GUEST_CACHE_NAME_PARTS = ["workbox-precache"];

function isGuestPwaCache(name) {
    return (
        GUEST_CACHE_PREFIXES.some((prefix) => name.startsWith(prefix)) ||
        GUEST_CACHE_NAME_PARTS.some((part) => name.includes(part))
    );
}

async function resetGuestPwaState() {
    if (!("serviceWorker" in navigator)) {
        cleanupGuestResetUrl();
        return;
    }

    const registrations = await navigator.serviceWorker.getRegistrations();
    const hadRegistrations = registrations.length > 0;

    if (hadRegistrations) {
        await Promise.all(registrations.map((registration) => registration.unregister()));
    }

    if ("caches" in window) {
        const cacheNames = await caches.keys();
        const guestCacheNames = cacheNames.filter((name) => isGuestPwaCache(name));

        await Promise.all(guestCacheNames.map((name) => caches.delete(name)));
    }

    if (hadRegistrations && !sessionStorage.getItem(GUEST_RESET_FLAG)) {
        sessionStorage.setItem(GUEST_RESET_FLAG, "1");

        const url = new URL(window.location.href);
        url.searchParams.set(GUEST_RESET_PARAM, Date.now().toString());
        window.location.replace(url.toString());
        return;
    }

    cleanupGuestResetUrl();
    sessionStorage.removeItem(GUEST_RESET_FLAG);
}

function cleanupGuestResetUrl() {
    const url = new URL(window.location.href);

    if (!url.searchParams.has(GUEST_RESET_PARAM)) {
        return;
    }

    url.searchParams.delete(GUEST_RESET_PARAM);
    window.history.replaceState({}, document.title, url.toString());
}

// Formulários com data-single-submit só podem ser enviados uma vez (evita duplo clique / Enter + toque)
function lockSubmitButtons(form, locked) {
    form.querySelectorAll('button[type="submit"], button:not([type])').forEach((button) => {
        button.disabled = locked;
    });
}

document.addEventListener("submit", (event) => {
    const form = event.target;

    if (event.defaultPrevented || !(form instanceof HTMLFormElement) || !form.hasAttribute("data-single-submit")) {
        return;
    }

    if (form.dataset.submitting === "true") {
        event.preventDefault();
        return;
    }

    form.dataset.submitting = "true";
    lockSubmitButtons(form, true);
});

// Página restaurada do bfcache (botão Voltar do navegador): libera os formulários novamente
window.addEventListener("pageshow", (event) => {
    if (!event.persisted) {
        return;
    }

    document.querySelectorAll("form[data-single-submit]").forEach((form) => {
        delete form.dataset.submitting;
        lockSubmitButtons(form, false);
    });
});

resetGuestPwaState().catch((error) => {
    console.warn("guest pwa reset failed", error);
    cleanupGuestResetUrl();
});
